<template>
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow"
    :title="$t('cos.static_website_configuration')" :default-cancel="false" @close="closeDialog" :width="dialogWidth"
    :closeTriggers="['esc']">

    <div class="param-bd" v-if="!hasAuth || errorMsg">
      <p class="text-center" style="margin: 20px 0"> {{errorMsg}} </p>
    </div>
    <ul class="form-list" v-else>
      <li class="pure-text-row">
        <div class="form-label"><label>{{$t('core.curr_status')}}</label></div>
        <div class="form-input">
          <div class="form-unit">
            <template v-if="!isEdit">
              <p class="form-text">
                <qc-icon type="loading" v-if="loading"></qc-icon>
                <template v-else>
                  {{info.NeedWebsite ? $t('core.on') : $t('core.off')}}
                  <a href="javascript:void(0);" class="js-copy-access-link" @click="handleEdit">
                    <i class="pencil-icon" :title="$t('core.edit')"></i>
                  </a>
                </template>
              </p>
            </template>
            <qc-switch v-else v-model="editInfo.NeedWebsite" @change="handleOpenStaicWeb"></qc-switch>
          </div>
        </div>
      </li>

      <template v-if="editInfo.NeedWebsite && isEdit">
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.endpoint')}}</label>
          </div>
          <div class="form-input">
            <p>{{editInfo.accessUrl}}</p>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.force_HTTPS')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <qc-switch v-model="editInfo.redirectHttps" @change="handleRedirectHttps"></qc-switch>
            </div>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.index_document')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit" :class="{'is-error': errorStatus.suffix.isError}">
              <qc-input v-model="editInfo.suffix" :placeholder="$t('cos.placeholder.such_as_index_html')"
                @input="suffixValidate"></qc-input>
              <p class="form-input-help">{{errorStatus.suffix.msg}}</p>
            </div>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.error_document.name')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit" :class="{'is-error': errorStatus.errorDocument.isError}">
              <qc-input v-model="editInfo.errorDocument" :placeholder="$t('cos.placeholder.such_as_pages_error_html')"
                @input="errorDocumentValidate"></qc-input>
              <p class="form-input-help">{{errorStatus.errorDocument.msg}}</p>
            </div>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.redirect_rules')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <qc-table :list="editInfo.RoutingRules" :show-pagination="false" min-height="auto">

                <qc-table-column :label="$t('core.type')" field="type" :width="120">
                  <template slot-scope="{ rowIndex }">
                    <div>
                      <qc-select class="dark-theme" width="180px" v-model="editInfo.RoutingRules[rowIndex].type">
                        <qc-option value="errcode">{{$t('cos.static_website.http_error_code')}}</qc-option>
                        <qc-option value="prefix">{{$t('cos.static_website.prefix_matches_with')}}</qc-option>
                      </qc-select>
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('core.description')" field="desc">
                  <template slot-scope="{ rowIndex }">
                    <div v-if="editInfo.RoutingRules[rowIndex].type === 'errcode'" :class="{'is-error':
                      errorStatus.routingRulesErrorCode[rowIndex]||errorStatus.routingRulesPrefix[rowIndex]}"
                      class="form-unit">
                      <qc-bubble popupClass="dark-theme" type="error"
                        :show="!!errorStatus.routingRulesErrorCode[rowIndex]">
                        <qc-input :placeholder="$t('cos.placeholder.support_4xx_error_code')"
                          v-model="editInfo.RoutingRules[rowIndex].errcode"
                          @input="routingRulesErrorCodeValidate($event, rowIndex)"></qc-input>
                        <template slot="popup">{{errorStatus.routingRulesErrorCode[rowIndex]}}</template>
                      </qc-bubble>
                    </div>
                    <div v-else>
                      <qc-bubble popupClass="dark-theme" type="error"
                        :show="!!errorStatus.routingRulesPrefix[rowIndex]">
                        <qc-input :placeholder="$t('cos.placeholder.enter_prefix_such_as_images')"
                          v-model="editInfo.RoutingRules[rowIndex].prefix"
                          @input="routingRulesPrefixValidate($event, rowIndex)"></qc-input>
                        <template slot="popup">{{errorStatus.routingRulesPrefix[rowIndex]}}</template>
                      </qc-bubble>
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('cos.static_website.force_HTTPS')" field="https" :width="120">
                  <template slot-scope="{ rowIndex }">
                    <div>
                      <qc-switch :checked.sync="editInfo.RoutingRules[rowIndex].https"></qc-switch>
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('core.rule')" field="rule" :width="120">
                  <template slot-scope="{ rowIndex }">
                    <div>
                      <template v-if="editInfo.RoutingRules[rowIndex].type === 'errcode'">
                        {{$t('cos.static_website.replace_path')}}
                      </template>
                      <template v-else>
                        <qc-select class="dark-theme" width="180px" v-model="editInfo.RoutingRules[rowIndex].rule">
                          <qc-option value="prefix">{{$t('cos.static_website.replace_prefix')}}</qc-option>
                          <qc-option value="path">{{$t('cos.static_website.replace_path')}}</qc-option>
                        </qc-select>
                      </template>
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('cos.static_website.replace_content')" field="path">
                  <template slot-scope="{ rowIndex }">
                    <div>
                      <qc-bubble popupClass="dark-theme" type="error"
                        :show="!!errorStatus.routingRulesReplace[rowIndex]">
                        <qc-input :placeholder="editInfo.RoutingRules[rowIndex].rule === 'prefix' ?
                            $t('cos.placeholder.replace_prefix') : $t('cos.placeholder.replace_path')"
                          v-model="editInfo.RoutingRules[rowIndex].path"
                          @input="routingRulesReplaceValidate($event, rowIndex)">
                        </qc-input>
                        <template slot="popup">{{errorStatus.routingRulesReplace[rowIndex]}}</template>
                      </qc-bubble>
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('core.action')" field="https">
                  <template slot-scope="{ rowIndex }">
                    <div>
                      <a href="javascript:void(0);" @click="removeRedirectRule(rowIndex)">{{$t('core.del')}}</a>
                    </div>
                  </template>
                </qc-table-column>

                <a href="javascript:void(0);" slot="footer"
                  @click="addRedirectRule">{{$t('cos.static_website.add_rule.name')}}</a>
              </qc-table>
              <p class="form-input-help">{{$t('cos.static_website.add_rule.tip')}}</p>
            </div>
          </div>
        </li>
      </template>
      <template v-else-if="info.NeedWebsite && !isEdit">
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.endpoint')}}</label>
          </div>
          <div class="form-input">
            {{info.accessUrl}}
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.force_HTTPS')}}</label>
          </div>
          <div class="form-input">
            <p>{{(info.RedirectAllRequestsTo && info.RedirectAllRequestsTo.Protocol == "https") ?
                $t('core.on') : $t('core.off')}}</p>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.index_document')}}</label>
          </div>
          <div class="form-input">
            <p>{{info.IndexDocument.Suffix.replace(/ /g, "&nbsp;")}}</p>
          </div>
        </li>
        <li class="pure-text-row">
          <div class="form-label">
            <label>{{$t('cos.static_website.error_document.name')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">
              <p style="font-size:12px">{{info.ErrorDocument.Key.replace(/ /g, "&nbsp;") || $t('core.empty')}}</p>
              <p v-show="info.ErrorDocument.Key" class="form-input-help">
                {{$t('cos.static_website.error_document.tip')}}
              </p>
            </div>
          </div>
        </li>
        <li>
          <div class="form-label">
            <label>{{$t('cos.static_website.redirect_rules')}}</label>
          </div>
          <div class="form-input">
            <div class="form-unit">

              <qc-table :list="info.RoutingRules" :show-pagination="false" min-height="auto">

                <qc-table-column :label="$t('core.type')" field="type" :width="120">
                  <template slot-scope="{ item }">
                    <div>
                      {{item.Condition.HttpErrorCodeReturnedEquals ? $t('core.ErrorCode') : $t('core.PrefixConfiguration')}}
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('core.description')" field="desc">
                  <template slot-scope="{ item }">
                    <div>
                      {{item.Condition.HttpErrorCodeReturnedEquals ?
                          item.Condition.HttpErrorCodeReturnedEquals : item.Condition.KeyPrefixEquals}}
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('cos.static_website.force_HTTPS')" field="https" :width="120">
                  <template slot-scope="{ item }">
                    <div>
                      {{item.Redirect.Protocol == "https" ?
                        $t('cos.static_website.enabled') : $t('cos.static_website.closed')}}
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('core.rule')" field="rule" :width="120">
                  <template slot-scope="{ item }">
                    <div>
                      {{item.Redirect.ReplaceKeyWith ?
                        $t('cos.placeholder.replace_path') : $t('cos.placeholder.Replace_path_prefix')}}
                    </div>
                  </template>
                </qc-table-column>

                <qc-table-column :label="$t('cos.static_website.replace_content')" field="path">
                  <template slot-scope="{ item }">
                    <div>
                      {{item.Redirect.ReplaceKeyWith ?
                          item.Redirect.ReplaceKeyWith : item.Redirect.ReplaceKeyPrefixWith}}
                    </div>
                  </template>
                </qc-table-column>
              </qc-table>
              <p class="form-input-help">{{$t('cos.static_website.add_rule.tip')}}</p>
            </div>
          </div>
        </li>
      </template>

    </ul>

    <p class="exter-link" style="margin-top: 20px">
      <a :href="learnMoreLink" target="_blank">
        {{ $t('cos.static_website.learn_more') }}<i class="external-link-icon"></i>
      </a>
    </p>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" v-if="isEdit" :disabled="disableSubmit" @click="onSubmit" :title="$t('core.ok')">
            {{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps, tips } from '@/scripts/tools/utils';
import dialog from '@/scripts/tools/dialog';
import cos from '@/scripts/helper/cos';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,

      hasAuth: true,
      errorMsg: '',
      isEdit: false,
      info: {},
      editInfo: {},
      errorStatus: {
        suffix: {
          isError: false,
          msg: this.$t('cos.static_website.suffix_validate[0]'),
        },
        errorDocument: {
          isError: false,
          msg: this.$t('cos.static_website.error_document_validate[0]'),
        },
        // 重定向规则
        routingRulesErrorCode: {},
        routingRulesPrefix: {},
        routingRulesReplace: {},
      },
      dialogWidth: 500,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    bucketInfoProxy: getInnerProps('bucketInfo'),
    disableSubmit() {
      // 检查表单输入
      if (
        !this.editInfo.suffix
        || this.editInfo.suffix.includes('?')
        || this.editInfo.suffix.includes('/')
        || this.editInfo.suffix.indexOf('/') === 0
      ) {
        return true;
      }

      if (this.editInfo.errorDocument.includes('?')) {
        return true;
      }

      // 检查表格输入
      let disabled = false;
      for (let i = 0; i < this.editInfo.RoutingRules.length; i++) {
        const item = this.editInfo.RoutingRules[i];
        if (!item.path || item.path.includes('?')) {
          disabled = true;
          break;
        }
        if (item.type === 'errcode') {
          if (!item.errcode || !/^4\d{2}$/.test(item.errcode)) {
            disabled = true;
          }
        } else if (!item.prefix || item.prefix.includes('?')) {
          disabled = true;
        }
      }

      return disabled;
    },
    learnMoreLink() {
      return this.$store.localeLanguage === 'zh'
        ? 'https://cloud.tencent.com/document/product/436/14984'
        : 'https://www.tencentcloud.com/document/product/436/30958?lang=en&pg=';
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.loading = true;
        this.resetData();
        this.getWebsiteInfo();
      } else {
        this.errorMsg = '';
      }
    },
  },
  methods: {
    suffixValidate(val) {
      let isError = true;
      const validateMsgs = this.$t('cos.static_website.suffix_validate');
      let msg = validateMsgs[0];
      if (!val.trim()) {
        [, msg] = validateMsgs;
      } else if (val.includes('?') || val.includes('/')) {
        [, , msg] = validateMsgs;
      } else if (val.indexOf('/') === 0) {
        [, , , msg] = validateMsgs;
      } else {
        isError = false;
      }
      this.errorStatus.suffix = {
        isError,
        msg,
      };
    },
    errorDocumentValidate(val) {
      let isError = true;
      let msg = this.$t('cos.static_website.error_document_validate[0]');
      if (val.includes('?')) {
        msg = this.$t('cos.static_website.error_document_validate[1]');
      } else {
        isError = false;
      }
      this.errorStatus.errorDocument = {
        isError,
        msg,
      };
    },
    routingRulesErrorCodeValidate(val, index) {
      let msg = '';
      if (!val) {
        msg = this.$t(
          'cos.static_website.routing_rules_error_code_validate[0]',
        );
      } else if (!/^4\d{2}$/.test(val)) {
        msg = this.$t(
          'cos.static_website.routing_rules_error_code_validate[1]',
        );
      }
      this.errorStatus.routingRulesErrorCode[index] = msg;
    },
    routingRulesPrefixValidate(val, index) {
      let msg = '';
      if (!val) {
        msg = this.$t('cos.static_website.routing_rules_prefix_validate[0]');
      }
      if (val.includes('?')) {
        msg = this.$t('cos.static_website.routing_rules_prefix_validate[1]');
      }
      this.errorStatus.routingRulesPrefix[index] = msg;
    },
    routingRulesReplaceValidate(val, index) {
      let msg = '';
      if (!val) {
        msg = this.$t('cos.static_website.routing_rules_replace_validate[0]');
      }
      if (val.includes('?')) {
        msg = this.$t('cos.static_website.routing_rules_replace_validate[1]');
      }
      this.errorStatus.routingRulesReplace[index] = msg;
    },

    getWebsiteInfo() {
      const { bucketInfo } = this;
      const { Bucket, Region } = bucketInfo;
      cos.getBucketWebsite(bucketInfo, (err, data) => {
        let Website = `${Bucket}.cos-website.${Region}.myqcloud.com`;
        if (err || data.statusCode === 404) {
          Website = '';
        }

        if (Website !== bucketInfo.Website) {
          this.bucketInfoProxy = { ...bucketInfo, Website };
        }

        if (err) {
          const { error } = err;
          if (error && error.Code === 'AccessDenied') {
            this.errorMsg = this.$t(
              'error.no_permissions_to_get_bucket_website',
            );
            this.hasAuth = false;
          } else {
            this.errorMsg = this.$t('state.fail.get_website_details');
          }
        } else {
          const { WebsiteConfiguration } = data;
          this.info = {
            NeedWebsite: Object.keys(WebsiteConfiguration).length > 0,
            accessUrl: `https://${Bucket}.cos-website.${Region}.myqcloud.com`,
            IndexDocument: WebsiteConfiguration.IndexDocument || {
              Suffix: 'index.html',
            },
            ErrorDocument: WebsiteConfiguration.ErrorDocument || { Key: '' },
            RedirectAllRequestsTo:
              WebsiteConfiguration.RedirectAllRequestsTo || {},
            RoutingRules: WebsiteConfiguration.RoutingRules || [],
          };
          if (this.info.NeedWebsite) {
            this.dialogWidth = 800;
          }
          this.isEdit = false;
        }

        this.loading = false;
      });
    },
    handleEdit() {
      this.editInfo = {
        NeedWebsite: this.info.NeedWebsite,
        accessUrl: this.info.accessUrl,
        suffix: this.info.IndexDocument.Suffix || 'index.html',
        redirectHttps: this.info.RedirectAllRequestsTo.Protocol === 'https',
        errorDocument: this.info.ErrorDocument.Key || '',
        RoutingRules: this.info.RoutingRules.map(item => ({
          type: item.Condition.HttpErrorCodeReturnedEquals
            ? 'errcode'
            : 'prefix',
          errcode: item.Condition.HttpErrorCodeReturnedEquals || '',
          prefix: item.Condition.KeyPrefixEquals || '',
          https: item.Redirect.Protocol === 'https',
          rule: item.Redirect.ReplaceKeyWith ? 'path' : 'prefix',
          path:
            item.Redirect.ReplaceKeyWith || item.Redirect.ReplaceKeyPrefixWith,
        })),
      };
      this.isEdit = true;
      if (this.info.NeedWebsite) {
        this.dialogWidth = 1200;
      }
    },
    handleOpenStaicWeb(val) {
      if (val) {
        this.dialogWidth = 1200;
      } else {
        this.dialogWidth = 500;
      }
    },
    addRedirectRule() {
      this.editInfo.RoutingRules.push({
        type: 'errcode',
        desc: '',
        https: false,
        rule: 'prefix',
        path: '',
      });
      const len = this.editInfo.RoutingRules.length;
      this.errorStatus.routingRulesErrorCode[len - 1] = '';
      this.errorStatus.routingRulesPrefix[len - 1] = '';
    },
    removeRedirectRule(index) {
      this.editInfo.RoutingRules.splice(index, 1);
      this.updateSubmitBtn();
    },
    handleRedirectHttps(val) {
      if (val) {
        const params = {
          ...this.$t('cos.static_website.enable_force_HTTPS_confirm'),
          width: 500,
        };
        dialog.confirm(params, confirm => {
          if (!confirm) {
            this.editInfo.redirectHttps = false;
          }
        });
      }
    },
    onSubmit() {
      const { bucketInfo } = this;
      const { Bucket, Region } = bucketInfo;
      const params = {
        Bucket,
        Region,
      };

      const handleResponse = (err, data) => {
        if (data) {
          // 设置成功
          tips.success(this.$t('state.success.set'));
          this.getWebsiteInfo();
        } else {
          const { error } = err;
          const code = (error && error.Code) || err;
          if (code === 'AccessDenied') {
            tips.error(this.$t('error.no_permissions_to_put_bucket_website'));
          } else {
            tips.error(window.lang.err(`error['${code}']`, err));
          }
        }
      };
      // 设置静态网站配置
      if (this.editInfo.NeedWebsite) {
        const WebsiteConfiguration = {};
        WebsiteConfiguration.IndexDocument = {
          Suffix: this.editInfo.suffix.trim(),
        };

        if (this.editInfo.errorDocument) {
          WebsiteConfiguration.ErrorDocument = {
            Key: this.editInfo.errorDocument.trim(),
          };
        }

        if (this.editInfo.redirectHttps) {
          WebsiteConfiguration.RedirectAllRequestsTo = { Protocol: 'https' };
        }

        if (this.editInfo.RoutingRules.length) {
          WebsiteConfiguration.RoutingRules = this.editInfo.RoutingRules.map(
            item => {
              const obj = {
                Condition: {},
                Redirect: {},
              };
              if (item.type === 'errcode') {
                obj.Condition.HttpErrorCodeReturnedEquals = item.errcode;
                obj.Redirect.ReplaceKeyWith = item.path;
              } else {
                obj.Condition.KeyPrefixEquals = item.prefix;
                if (item.rule === 'prefix') {
                  obj.Redirect.ReplaceKeyPrefixWith = item.path;
                } else {
                  obj.Redirect.ReplaceKeyWith = item.path;
                }
              }
              if (item.https) {
                obj.Redirect.Protocol = 'https';
              }
              return obj;
            },
          );
        }
        params.WebsiteConfiguration = WebsiteConfiguration;
        cos.putBucketWebsite(params, handleResponse);
      } else {
        // 删除静态网站配置
        cos.deleteBucketWebsite(params, handleResponse);
      }
    },
    resetData() {
      const data = {
        hasAuth: true,
        isEdit: false,
        info: {},
        editInfo: {},
        errorStatus: {
          suffix: {
            isError: false,
            msg: this.$t('cos.static_website.suffix_validate[0]'),
          },
          errorDocument: {
            isError: false,
            msg: this.$t('cos.static_website.error_document_validate[0]'),
          },
          routingRulesErrorCode: {},
          routingRulesPrefix: {},
          routingRulesReplace: {},
        },
        dialogWidth: 500,
      };
      Object.keys(data).forEach(key => {
        this[key] = data[key];
      });
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.item-descr-list .item-descr-tit {
  vertical-align: middle;
}
.tc-15-menu-active {
  z-index: 2001;
}
</style>
